import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { classes } from 'typestyle';

import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { DataConnections } from '~src/datasource/dataConnection/resources/DataConnections';
import { CardTextAndLink } from '~src/spacesPlatform/components/card/CardTextAndLink';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ConnectionDisplay } from '~src/spacesPlatform/components/ListView/DataConnectionComponents';

import { Messages } from '../../../../../codegen/Localize';
import { IDataConnectionInfo } from '../../../models/IDataConnectionInfo';

export type DataconnectionThumbnailProps = SiteUrlsProps & Pick<React.AriaAttributes, 'aria-label'> & {
  readonly dataconnection: IDataConnectionInfo;
  readonly datasourceContentUrl: string;
  readonly metadata: ConnectionDisplay.Metadata;
  readonly hovered?: boolean;
  readonly selected?: boolean;
}

export class DataconnectionThumbnail extends React.Component<DataconnectionThumbnailProps> {
  public render() {
    let containerClass = this.cardUrl() ? CardViewStyles.CustomThumbnail : CardViewStyles.CustomThumbnailNoLinkPointer;

    /* eslint-disable jsx-a11y/alt-text */
    /* eslint-disable jsx-a11y/anchor-has-content */
    return (
      <div className={classes(containerClass, {
        [CardViewStyles.SelectedClassName]: this.props.selected,
        [CardViewStyles.HoveredClassName]: this.props.hovered && !this.props.selected
      })}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={CardViewStyles.DataconnectionThumbnailDatasourceLink}>
              <CardTextAndLink
                text={Messages.datasource()}
                url={this.props.datasourceContentUrl}
                urlDisplayName={this.props.dataconnection.datasource.name}
                style={{
                  /* Make sure the card checkbox doesn't cover the text */
                  marginLeft: TabStyles.Spacing.MediumSpace,
                  maxWidth: CardViewStyles.CardTextAndLinkMaxWidth - 30
                }}
              />
            </div>
            <div className={CardViewStyles.CustomThumbnailImg}>
              <img src={this.props.metadata.cardIconUrl}/>
            </div>
          </div>
        </div>
        <div className={CardViewStyles.DataconnectionThumbnailConnectionType}>
          {this.props.metadata.connectionType}
        </div>
        <div>
          <React.Fragment>
            <div>
              {this.authentication()}
            </div>
            <div className={CardViewStyles.DataconnectionThumbnailUsername}>
              {DataConnections.getDisplayUsername(this.props.dataconnection) || <span>&nbsp;</span>}
            </div>
          </React.Fragment>
        </div>
        {this.cardUrl() &&
          <a href={this.cardUrl()} className={classes(CardViewStyles.AnchorUnderlay, CardViewStyles.ThumbnailFocus)} aria-label={this.props['aria-label']}></a>}
      </div>
    );
  }

  private cardUrl = (): string => {
    return this.props.metadata.href || this.props.datasourceContentUrl;
  };

  private authentication(): string {
    const authentication = DataConnections.getDisplayAuthentication(this.props.dataconnection);
    if (authentication === Messages.none()) {
      return Messages.editDataConnections_generic_noCredential();
    }

    return authentication;
  }
}
